import React from 'react';
import styled from 'styled-components';
export default function FormBody({ children, className, }) {
    return (React.createElement(StyledFormBody, { className: className }, children));
}
const StyledFormBody = styled.div `
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
`;
